

import { useAuthStore } from "../../store";





export const useValidarRoles = () => {

    
    const { usuario } = useAuthStore();


    const isRolPermitido = (roles) => {
        return roles.includes(usuario?.role)
    }



    return {
        isRolPermitido,
    }


}
